import { TableCellEmpty } from '@/components/custom';
import { getTitleEnumValue } from '@/functions';
import { TableCell } from '@/components/ui';
import { IHasCreator } from '@/interfaces';

export const DataTableBodyCellPaymentInfoMethod = ({ creator }: IHasCreator) => (
  <TableCell className='py-1 pe-0 w-36'>
    {
      creator.paymentInfo?.method
        ? getTitleEnumValue('PaymentMethodEnum', creator.paymentInfo.method)
        : <TableCellEmpty text='Non défini' />
    }
  </TableCell>
);

export default DataTableBodyCellPaymentInfoMethod;
